import { FIREBALL_IDS } from '../fireball/fireballMath';

// ARBUZ alkane on-chain identifier (decimal, new API format)
export const ARBUZ_RUNE = {
  BLOCK: 2,
  TX: 25349,
};

// ARBUZ mint transaction parameters
export const ARBUZ_MINT = {
  OUTPUT_AMOUNT: 330,
  SERVICE_FEE: 1069,
  MIN_TX_SIZE: 251,
  SERVICE_FEE_ADDRESS: 'bc1qta5glek90en6pd70mq9fguwel0xrlghmv6r09e',
  PROTOSTONE_PARAMS: { param1: 2, param2: 25349, param3: 77 },
};

// Fireball / Arbuzino lottery contracts — deployed on mainnet (decimal AlkaneIds).
// Single numeric source of truth is FIREBALL_IDS in fireball/fireballMath.js; the string
// forms below are DERIVED from it so a redeploy only ever edits that one place.
const fbId = ({ block, tx }) => `${block}:${tx}`;
export const FIREBALL = {
  GAME: fbId(FIREBALL_IDS.GAME),               // fireball-game — BuyTicket / RecordBall / Claim / views
  POSITION: fbId(FIREBALL_IDS.POSITION_TEMPLATE), // fireball-position-token — the ticket NFT (clones at 2:N)
  VAULT: fbId(FIREBALL_IDS.VAULT),             // fireball-vault — protocol fee accrues here for stakers
};

// SUBFROST frBTC — wrapped BTC alkane [32:0]. A wrap sends BTC to the FROST signer
// output and the contract mints frBTC to the user (see useWrapSwapBuy). Mirrors subfrost-app's
// flow; the signer P2TR is HARDCODED to the mainnet federation key (subfrost does the
// same on mainnet to avoid a GET_SIGNER simulate per wrap). If the federation rotates
// its key this MUST be updated — a stale signer means BTC sent but no frBTC minted.
export const FRBTC = {
  BLOCK: 32,
  TX: 0,
  WRAP_OPCODE: 77,            // exchange BTC → frBTC
  UNWRAP_OPCODE: 78,          // frBTC → BTC (not wired yet)
  FEE_PER_1000: 1,            // 0.1% protocol wrap fee (frBTC minted = floor(sats*999/1000))
  SIGNER_ADDRESS: 'bc1p5lushqjk7kxpqa87ppwn0dealucyqa6t40ppdkhpqm3grcpqvw9s3wdsx7', // mainnet FROST signer P2TR
};

// Coldstern Engine — stateless, immutable OYL swap proxy at 4:999 (mainnet, deployed
// 2026-06-22). Swaps frBTC↔DIESEL through the OYL pool with exact-in/exact-out + a
// slippage bound and change. We use SwapExactOut to buy an exact lottery-ticket price.
export const COLDSTERN = {
  BLOCK: 4,
  TX: 999,
  SWAP_EXACT_IN: 1,
  SWAP_EXACT_OUT: 2,
  SLIPPAGE_BPS: 1000,         // 10% — exact-out amount_in_max headroom (display + hook share this)
  FEE_PER_1000: 10,           // OYL pools run the default 1% fee (hardcoded in coldstern-math)
  POOL_GET_RESERVES: 97,      // pool view opcode → (reserve_0, reserve_1) as 2×u128 LE
  // OYL DIESEL/frBTC pool. token0 = DIESEL (2:0, smaller id) → reserve_0; token1 = frBTC
  // (32:0) → reserve_1. ⚠️ Confirm with a live GetReserves before any mainnet swap.
  POOL: { BLOCK: 2, TX: 77087 },
};

// DIESEL — alkanes genesis token (the lottery's bet currency, and the swap's token_out).
export const DIESEL_ID = { BLOCK: 2, TX: 0 };

// Card mint transaction parameters
export const CARD_MINT = {
  OUTPUT_AMOUNT: 330,
  PROTOSTONE_PARAMS: { param1: 2, param2: 69849, param3: 77 },
};

// API endpoints
export const API = {
  RPC_ENDPOINT: import.meta.env.VITE_RPC_MAINNET || '/api/rpc',
  REBAR_INFO: 'https://shield.rebarlabs.io/v1/info',
  REBAR_RPC: 'https://shield.rebarlabs.io/v1/rpc',
  MEMPOOL_FEES: 'https://mempool.space/api/v1/fees/recommended',
};

// Inugami bounty (DIESEL locked against a coinbase phrase).
// PHRASE is consensus-significant: a miner must write these exact bytes into their
// coinbase scriptSig to claim - the UI copies of the phrase must stay byte-identical.
export const INUGAMI = {
  PHRASE: '🍉MAGIC ARBUZ🔮',
  ALKANE: '2:69834',
  PRICE_POOL: '2:0-usd',   // DIESEL/USD ammdata pool for the fiat estimate
};

export const DUST_THRESHOLD = 546;

// Sanity ceiling for the user-typed custom fee rate (sat/vB) - a fat-fingered
// "99999" would otherwise produce a multi-BTC fee on a 251 vB tx.
export const MAX_CUSTOM_FEE_RATE = 2000;

// User-facing block explorer (transaction view)
export const EXPLORER_TX = (txid) => `https://espo.sh/tx/${txid}`;
// Alkane contract view (e.g. https://espo.sh/alkane/4:257)
export const EXPLORER_ALKANE = (id) => `https://espo.sh/alkane/${id}`;

// Mining pools the Acai contract accepts - a successful Arbuz mint requires the
// including block to be mined by one of these. Single source of truth for the
// ReadMe pool list (desktop + mobile) and the activity-feed SPOILED detection.
export const ALLOWED_POOLS = [
  'AntPool', 'WhitePool', 'Binance Pool', 'Mining Squared',
  'BTC.com', 'Braiins Pool', 'ULTIMUSPOOL', 'Poolin',
];
